import React from "react";

import ServicesFormUI from "0.Mine/0.Components/BusinessCard/Services/UI/BusinessServiceManager";
import { BusinessService } from "0.Mine/3.Interfaces/Services";

import { useServicesFormLogic } from "../../Logic/ServicesForm/ServicesFormOnboarding";

interface ServicesFormProps {
  initialValue: BusinessService[];
  updateBusinessData: (data: BusinessService[]) => void;
}

const ServicesForm: React.FC<ServicesFormProps> = ({ initialValue, updateBusinessData }) => {
  const {
    treatments,
    handleAddTreatment,
    handleDeleteTreatment,
    handleReorderTreatments,
    handleUpdateTreatment,
  } = useServicesFormLogic({ initialValue, updateBusinessData });

  return (
    <ServicesFormUI
      businessid={1}
      treatments={treatments}
      onAdd={handleAddTreatment}
      onDelete={handleDeleteTreatment}
      onReorder={handleReorderTreatments}
      onUpdate={handleUpdateTreatment}
    />
  );
};

export default ServicesForm;
